import React, { useState, useEffect } from "react";
import { Alert, Modal, Button } from "react-bootstrap";
import {
  openCheckout,
  createOrder,
  updateCartCache,
  getShippingCharges,
  getShippingNumber,
  getCartCache,
} from "../../helper";
import { useHistory } from "react-router-dom";
import STRING from "../../constants/strings";
import CHARGES from "../../constants/charges";
import ConfirmShippingCharges from "../ConfirmShippingCharges/index";
import LoadingModal from "../LoadingModal";
import "./styles.scss";

function PlaceOrder(props) {
  const {
    show,
    closeModal,
    loggedIn,
    cartAmount,
    cart,
    shippingCharges,
    isStorePickup,
    user_attributes,
    confirmAddress,
    codApplied,
    showAlert,
    isMobile,
    showLoader,
    setShippingCharges,
    setShippingChargesConfirmed,
    shippingChargesConfirmed,
    cancelPlaceOrder,
    selectedStorePickupSlot,
    selectedStorePickupDate,
  } = props;
  const history = useHistory();
  const [showConfirmShippingCharges, setShowConfirmShippingCharges] =
    useState(false);

  const { username } = user_attributes;
  const [showLoadingModal, setShowLoadingModal] = useState(true);
  useEffect(() => {
    let shippingChargesUser = Object.assign({}, user_attributes);
    shippingChargesUser.username = getShippingNumber(username);
    if (
      !shippingChargesConfirmed &&
      !isStorePickup &&
      !showConfirmShippingCharges
    ) {
      getShippingCharges({
        address: confirmAddress,
        user_attributes: shippingChargesUser,
        COD: codApplied ? 1 : 0,
        products: cart,
      })
        .then((result) => {
          if (Number(result) === shippingCharges) {
            setShippingChargesConfirmed(true);
          } else {
            setShowConfirmShippingCharges(true);
            setShippingCharges(Number(result));
          }
          setShowLoadingModal(false);
        })
        .catch((error) => {
          showAlert("Shipping Charges", error.response.data.error);
          cancelPlaceOrder();
          setShowLoadingModal(false);
        });
    } else {
      setShowLoadingModal(false);
    }
  }, [
    shippingChargesConfirmed,
    confirmAddress,
    user_attributes,
    codApplied,
    showAlert,
    setShippingCharges,
    username,
    showLoader,
    isStorePickup,
    cancelPlaceOrder,
    setShippingChargesConfirmed,
    showConfirmShippingCharges,
    shippingCharges,
    cart,
  ]);

  const handleConfirmSubmit = async () => {
    var totalAmount = isStorePickup
      ? cartAmount
      : cartAmount + (shippingCharges || 0);
    const processingFee = isStorePickup
      ? (CHARGES.PROCESSING_PERCENTAGE * (totalAmount * 0.1)).toFixed(2)
      : (CHARGES.PROCESSING_PERCENTAGE * totalAmount).toFixed(2);

    let payload = {
      user_attributes: user_attributes,
      address: !isStorePickup ? confirmAddress : null,
      products: cart,
      is_store_pickup: isStorePickup || false,
      product_charges: Number(cartAmount),
      processing_fee: codApplied ? 0 : Number(processingFee),
      shipping_charges: shippingCharges || 0,
      total_amount: totalAmount,
      payment_method: codApplied ? "COD" : "Razorpay",
    };
    if (isStorePickup) {
      payload["pickup_date"] = selectedStorePickupDate;
      payload["pickup_slot"] = selectedStorePickupSlot;
    }
    if (!codApplied) {
      showLoader(true);
      const amount = payload["is_store_pickup"]
        ? (
            (
              payload["product_charges"] * 0.1 +
              payload["processing_fee"]
            ).toFixed(2) * 100
          ).toFixed(0)
        : (
            (payload["total_amount"] + payload["processing_fee"]).toFixed(2) *
            100
          ).toFixed(0);

      const cachedCart = getCartCache();
      await createOrder(payload)
        .then((result) => {
          updateCartCache(null, true);
          openCheckout(
            payload,
            amount,
            result.order_id,
            showLoader,
            cachedCart
          );
        })
        .catch((error) => {
          console.log(error);
          showLoader(false);
          showAlert(
            "Order",
            `${error.response.data.error}. Unable to place an order. Please try again after sometime.`
          );
        });
    } else {
      showLoader(true);
      await createOrder(payload)
        .then(() => {
          showAlert("Place Order", STRING.ORDER_PLACED_SUCCESSFULLY, true);
          updateCartCache(null, true);
          history.push("/thankyou", { isStorePickup: payload.is_store_pickup });
        })
        .catch(() => {
          showLoader(false);
          cancelPlaceOrder();
          setShippingChargesConfirmed(false);
          showAlert("Place Order", STRING.ORDER_PLACED_UNSUCCESSFULLY);
        });
    }
  };

  return (
    <>
      {showLoadingModal && <LoadingModal show={showLoadingModal} />}
      {loggedIn && (shippingChargesConfirmed || isStorePickup) && (
        <Modal onHide={closeModal} show={show} className="confirm-order-modal">
          <Alert variant="success" className={isMobile ? "w-100" : "w-50"}>
            <Alert.Heading>Confirm Order</Alert.Heading>
            <hr />
            <p>{STRING.CONFIRM_ORDER_DECLARATION}</p>
            <div className="d-flex justify-content-end">
              <div
                className="d-flex justify-content-between mt-2"
                style={{ width: isMobile ? "68%" : "30%" }}
              >
                <Button
                  className="w-50 mr-2"
                  onClick={() => {
                    handleConfirmSubmit();
                    closeModal();
                  }}
                  variant="outline-success"
                >
                  Confirm
                </Button>
                <Button
                  className="w-50"
                  onClick={() => {
                    cancelPlaceOrder();
                    setShippingChargesConfirmed(false);
                    closeModal();
                  }}
                  variant="outline-success"
                >
                  Review
                </Button>
              </div>
            </div>
          </Alert>
        </Modal>
      )}
      {showConfirmShippingCharges && (
        <ConfirmShippingCharges
          show={!showLoadingModal && showConfirmShippingCharges}
          setShippingChargesConfirmed={setShippingChargesConfirmed}
          closeModal={() => setShowConfirmShippingCharges(false)}
          cancelPlaceOrder={cancelPlaceOrder}
          isMobile={isMobile}
          shippingCharges={shippingCharges}
          setShippingCharges={setShippingCharges}
        />
      )}
      {showLoadingModal ? <LoadingModal show={showLoadingModal} /> : null}
    </>
  );
}

const areEqual = (prevProps, nextProps) =>
  prevProps.loggedIn === nextProps.loggedIn &&
  prevProps.shippingCharges === nextProps.shippingCharges &&
  prevProps.shippingChargesConfirmed === nextProps.shippingChargesConfirmed;

export default React.memo(PlaceOrder, areEqual);
